import type { QueryKey } from '@tanstack/react-query';
import type {
  GetFamilyMemberTransactionsPhoenixParams,
  GetTransactionsPhoenixParams,
} from './api';

export const TRANSACTIONS_PHOENIX_KEY = (
  params?: GetTransactionsPhoenixParams
): QueryKey => ['transactions-phoenix', params ?? {}];

export const FAMILY_MEMBER_TRANSACTIONS_PHOENIX_KEY = (
  params: GetFamilyMemberTransactionsPhoenixParams
): QueryKey => ['family-member-transactions-phoenix', params];
